const BUCKET_STYLE = {
  maintenance: "bg-amber-200/70 border-amber-400 text-amber-900",
  needs_inspection: "bg-amber-300/70 border-amber-500 text-amber-900",
  unavailable: "bg-slate-300/70 border-slate-400 text-slate-800",
  in_use: "bg-sky-200/70 border-sky-400 text-sky-900",
};

/** An "ongoing, no known end" vehicle-status block (maintenance / damaged /
 * unavailable / Needs Inspection / retired). Rendered open-ended: a start
 * edge with a fading tail, because the underlying data genuinely has no
 * end date (a single vehicle_maintenance record has only a point-in-time
 * `date`, never a range). Never fabricates an end. Clicking opens the
 * vehicle's own detail page, never a synthesized record. */
export function VehicleStateBlock({ block, left, width, onClick, testId }) {
  const cls = BUCKET_STYLE[block.subtype] || BUCKET_STYLE.unavailable;
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onClick?.(); }}
      data-testid={testId}
      title={block.label}
      style={{ left: `${left}%`, width: `${width}%` }}
      className={`absolute top-1 bottom-1 rounded-md border text-[10px] font-semibold px-1.5 flex items-center overflow-hidden ${cls}`}
    >
      <span className="truncate">{block.label}</span>
      <span className="ml-auto flex-shrink-0 opacity-70">→</span>
    </button>
  );
}
